import { Action, createReducer, on } from '@ngrx/store';
import * as StorageRackActions from './storage-rack.actions';
import { initialStorageRackState, StorageRackState } from './storage-rack.state';

const reducer = createReducer(
  initialStorageRackState,

  on(StorageRackActions.loadStorageRacks, (state) => ({
    ...state,
    loading: true,
  })),
  on(StorageRackActions.loadStorageRacksSuccess, (state, { storageRacks }) => ({
    ...state,
    storageRacks,
    loading: false,
  })),
  on(StorageRackActions.loadStorageRacksFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(StorageRackActions.loadStorageRackSuccess, (state, { storageRack }) => ({
    ...state,
    selectedStorageRack: storageRack,
  })),
  on(StorageRackActions.createStorageRackSuccess, (state, { storageRack }) => ({
    ...state,
    storageRacks: [...state.storageRacks, storageRack],
  })),
  on(StorageRackActions.updateStorageRackSuccess, (state, { storageRack }) => ({
    ...state,
    storageRacks: state.storageRacks.map((r) =>
      r.id === storageRack.id ? storageRack : r
    ),
  })),
  on(StorageRackActions.deleteStorageRackSuccess, (state, { id }) => ({
    ...state,
    storageRacks: state.storageRacks.filter((r) => r.id !== id),
  })),

  on(StorageRackActions.searchStorageRacks, (state) => ({
  ...state,
  loading: true
})),
on(StorageRackActions.searchStorageRacksSuccess, (state, { searchResults }) => ({
  ...state,
  searchResults,
  loading: false,
})),
on(StorageRackActions.searchStorageRacksFailure, (state, { error }) => ({
  ...state,
  error,
  loading: false,
}))

);

// ✅ This is what NgRx expects:
export function storageRackReducer(
  state: StorageRackState | undefined,
  action: Action
): StorageRackState {
  return reducer(state, action);
}
